<div
  class="button-card"
  [ngClass]="{ 'selected': isSelected() }"
  (click)="toggleSelection()"
>
  <div class="checkbox-indicator" [ngClass]="{ 'checked': isSelected() }">
    <kendo-icon *ngIf="isSelected()" name="check"></kendo-icon>
  </div>

  <div class="content">
    <!-- <kendo-icon [name]="icon()"></kendo-icon> -->
    <span [ngClass]="icon()"></span>
    <div class="label">{{ label() }}</div>
  </div>
</div>
